// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  getValue as _getValue,
  getString as _getString,
  getNumber as _getNumber,
  getBoolean as _getBoolean,
  getAll as _getAll
} from 'rxfire/remote-config';

export const getValueChanges = ɵzoneWrap(_getValue, true);
export const getStringChanges = ɵzoneWrap(_getString, true);
export const getNumberChanges = ɵzoneWrap(_getNumber, true);
export const getBooleanChanges = ɵzoneWrap(_getBoolean, true);
export const getAllChanges = ɵzoneWrap(_getAll, true);
